module.exports = __webpack_public_path__ + "img/language_handle.ab37586d.png";